var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionVehicleMetricsColoredDay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18V12C21.5523 12 22 11.5523 22 11C22 10.4477 21.5523 10 21 10H20L19.2785 5.6712C19.1178 4.70683 18.2834 4 17.3057 4H6.69425C5.71658 4 4.8822 4.70683 4.72147 5.6712L4 10H3C2.44772 10 2 10.4477 2 11C2 11.5523 2.44772 12 3 12V18.5C3 19.3284 3.67157 20 4.5 20C5.32843 20 6 19.3284 6 18.5V18H18.0854C18.0301 18.1564 18 18.3247 18 18.5C18 19.3284 18.6716 20 19.5 20C20.3284 20 21 19.3284 21 18.5C21 18.3247 20.9699 18.1564 20.9146 18H21ZM17.3057 6L17.9724 10H6.02759L6.69425 6H17.3057Z",
    fill: "#5714CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9724 10L17.3057 6H6.69425L6.02759 10H17.9724Z",
    fill: "#D1E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.0001C5.67157 12.0001 5 12.6716 5 13.5001C5 14.3285 5.67157 15.0001 6.5 15.0001C7.32843 15.0001 8 14.3285 8 13.5001C8 12.6716 7.32843 12.0001 6.5 12.0001Z",
    fill: "#FFBF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 12.0001C16.6716 12.0001 16 12.6716 16 13.5001C16 14.3285 16.6716 15.0001 17.5 15.0001C18.3284 15.0001 19 14.3285 19 13.5001C19 12.6716 18.3284 12.0001 17.5 12.0001Z",
    fill: "#FFBF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14C24 17.866 20.866 21 17 21C13.134 21 10 17.866 10 14C10 10.134 13.134 7 17 7C20.866 7 24 10.134 24 14Z",
    fill: "#FFC107"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18 12V10L16 10L16 12H18Z",
    fill: "#2D3C53"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18L18 14H16L16 18H18Z",
    fill: "#2D3C53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionVehicleMetricsColoredDay);
export default __webpack_public_path__ + "static/media/ic_action_vehicle_metrics_colored_day.a1a74b46790ab6b6ebe97ef7bed61ed1.svg";
export { ForwardRef as ReactComponent };